import { ASSETS } from "@/lib/assets";

export const Logo = ({ className = "h-8 w-auto", invert = false }) => (
  <img
    src={ASSETS.logo}
    alt="Vaultavo"
    className={className}
    style={invert ? { filter: "brightness(0) invert(1)" } : undefined}
    data-testid="vaultavo-logo"
  />
);

export default Logo;
